<script setup>
import { useGroupParticipant } from './composables/useGroupParticipant';
import { useMessageContext } from './provider.js';

const { sender, messageType } = useMessageContext();
const { shouldShowSenderName, senderName } = useGroupParticipant(
  sender,
  messageType
);
</script>

<template>
  <div
    v-if="shouldShowSenderName"
    class="text-xs font-semibold text-n-slate-11 mb-1"
  >
    {{ senderName }}
  </div>
</template>
